<div *ngIf="reviewSourceInfoMap$ | async as reviewSourceInfoMap" class="sources-wrapper">
  <ng-container *ngFor="let sourceId of sortedSelectedSources">
    <div *ngIf="reviewSourceInfoMap[sourceId] as source" class="source-container">
      <div class="source-label">
        <glxy-avatar [src]="source.sourceIconUrl" [width]="20" class="source-icon"></glxy-avatar>
        <span class="source-name">{{ source.sourceName }}</span>
        <span class="listing-name">{{ source.listingName }}</span>
      </div>
    </div>
  </ng-container>
</div>
